(function($) {
	$(function() {

		//# Variable product variation changes

		//# – Update price
		const price = {
			$: $('.entry-summary p.price'),
			update: function ( {price_html} ) {
				this.$.html( price_html ).addClass('woocommerce-variation-price');
			},
			reset: function () {
				this.$.html(this.orig).removeClass('woocommerce-variation-price');
			}
		};
		price.orig = price.$.html();

		$('.single_variation_wrap')
			.on( 'show_variation', (event, variation) => price.update(variation) )
			.on( 'hide_variation', () => price.reset() );

		//# Add plus/minus buttons to quantity
		const $qty = $('.cart .quantity').addClass('input-group');
		const $qtyInput = $qty.find('.qty').addClass('input-group-field');

		// Add buttons
		$qtyInput.before(`
			<div class="input-group-button">
				<button type="button" class="decQty button hollow form-border-color expanded">
					<span class="show-for-sr">Decrease quantity</span>
					<span aria-hidden="true">−</span>
				</button>
			</div>
		`);
		$qtyInput.after(`
			<div class="input-group-button">
				<button type="button" class="incQty button hollow form-border-color expanded">
					<span class="show-for-sr">Increase quantity</span>
					<span aria-hidden="true">+</span>
				</button>
			</div>
		`);

		// Hook button events
		$qty.find('.decQty').on( 'click', function () {
			$(this).closest('.input-group').find('.input-group-field')[0].stepDown();
		} );
		$qty.find('.incQty').on( 'click', function () {
			$(this).closest('.input-group').find('.input-group-field')[0].stepUp();
		} );

		$qtyInput.addClass('no-spinner');
	});
})(jQuery);
